import { isLoading } from "apollo/utils";
import { useEnvContext } from "context/EnvContext";
import { APP_CAREPROVIDER } from "core/consts";
import { useManualSetLegalDocuments } from "dsl/atoms/LegalDocuments";
import { useHandleLogin } from "dsl/ecosystems/CareproviderOnboardingLoginPage/useHandleLogin";
import { useCareproviderHandlerUrls } from "dsl/hooks/useNavigationHandlers";
import { CareproviderLoginForm } from "./CareproviderLoginForm/CareproviderLoginForm";

export function CareproviderLoginPage({
  careproviderToLog,
}: {
  careproviderToLog?: number;
}) {
  const { env } = useEnvContext();

  const {
    challengeTimestamp,
    handleLogin,
    loginErrors,
    loginView,
    progressLogin,
    resetError,
    setLoginView,
    setProgressLogin,
  } = useHandleLogin({ careproviderToLog });

  const {
    goToContactUs,
    goToForgotPassword,
    goToProductionEnv,
    goToSenderApp,
  } = useCareproviderHandlerUrls();

  // Setting the legal documents to default on the login screen, otherwise
  // it tries to fetch with the id (logout/onboarding), although logged out
  useManualSetLegalDocuments();

  return (
    <main>
      <CareproviderLoginForm
        app={APP_CAREPROVIDER}
        challengeTimestamp={challengeTimestamp}
        contactUsUrl={goToContactUs()}
        env={env}
        goToForgotPassword={goToForgotPassword()}
        goToProductionUrl={goToProductionEnv()}
        isLoading={isLoading(progressLogin)}
        loginErrors={loginErrors}
        loginView={loginView}
        otherAppUrl={goToSenderApp()}
        resetError={resetError}
        onBackToLogin={() => {
          resetError();
          setLoginView("login");
        }}
        onSubmit={(payload) => handleLogin(payload, setProgressLogin)}
      />
    </main>
  );
}
